import React, { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute, LayoutSplashScreen } from "../_metronic/layout";

// new routing
import Admin from "../_metronic/components/Roles/Admin";
import SuperAdmin from "../_metronic/components/Roles/SuperAdmin";
import User from "../_metronic/components/Roles/User";
import StandardAmenities from "../_metronic/components/Amenities/StandardAmenities";
import DistinctiveAmenities from "../_metronic/components/Amenities/DistinctiveAmenities";
import ContactUsAdmin from "../_metronic/components/ContactUs/ContactUsAdmin";
import ContactUsGeneral from "../_metronic/components/ContactUs/ContactUsGeneral";
import Properties from "../_metronic/components/Properties/Properties";
import Faqs from "../_metronic/components/Faqs/Faqs";
import AddProperty from "../_metronic/components/AddProperty/AddProperty";
import KnowMore from "../_metronic/components/KnowMore/KnowMore";
import BannerImage from "../_metronic/components/BannerImage/BannerImage";
//end

import DashboardPage from "./pages/DashboardPage";
import { getUserInfo } from "../../src/utils/user.util";
import AboutUS from "../_metronic/components/AboutUs/AboutUs";
import Cms from "../_metronic/components/Cms/Cms";
import MarketingBanner from "../_metronic/components/Banner/Banner";
import Howitworks from "../_metronic/components/Howitworks/Howitworks";
import Ourtrustedpartners from "../_metronic/components/Ourtrustedpartners/Ourtrustedpartners";
import PopularDestination from "../_metronic/components/PopularDestination/PopularDestination";
import EnjoyTheReturns from "../_metronic/components/EnjoyTheReturns/EnjoyTheReturns";

import SocialMedia from "../_metronic/components/SocialMedia/SocialMedia";
// import Logo from "../_metronic/components/Logo/Logo";
import CompanyDetails from "../_metronic/components/CompanyDetails/CompanyDetails";
// import AddProperty from "./pages/AddProperty";
export default function BasePage() {
  let userInfo = getUserInfo();

  return (
    <>
      {userInfo?.admin?.role === "superadmin" ? (
        <Suspense fallback={<LayoutSplashScreen />}>
          <Switch>
            <Redirect exact from="/" to="/dashboard" />
            <ContentRoute exact path="/dashboard" component={DashboardPage} />
            <ContentRoute exact path="/addproperty" component={AddProperty} />
            <ContentRoute
              exact
              path="/amenities/standard"
              component={StandardAmenities}
            />
            <ContentRoute
              exact
              path="/amenities/distinctive"
              component={DistinctiveAmenities}
            />
            <ContentRoute
              exact
              path="/contactUs/contactUsGeneral"
              component={ContactUsGeneral}
            />
            {/* <ContentRoute
              exact
              path="/contactUs/contactUsAdmin"
              component={ContactUsAdmin}
            /> */}
            <ContentRoute exact path="/properties" component={Properties} />
            <ContentRoute exact path="/roles/admin" component={Admin} />
            <ContentRoute
              exact
              path="/roles/superAdmin"
              component={SuperAdmin}
            />
            <ContentRoute exact path="/roles/user" component={User} />
            <ContentRoute exact path="/faqs" component={Faqs} />
            <ContentRoute exact path="/aboutus" component={AboutUS} />
            <ContentRoute exact path="/bannerimage" component={BannerImage} />
            <ContentRoute exact path="/knowMore" component={KnowMore} />
            {/* <ContentRoute exact path="/logo" component={Logo} /> */}
            <ContentRoute exact path="/cms" component={Cms} />
            <ContentRoute exact path="/companydetails" component={CompanyDetails} />
            <ContentRoute exact path="/marketingbanner" component={MarketingBanner} />
            <ContentRoute exact path="/howitworks" component={Howitworks} />
            <ContentRoute exact path="/ourtrustedpartners" component={Ourtrustedpartners} />
            <ContentRoute exact path="/populardestination" component={PopularDestination} />
            <ContentRoute exact path="/enjoythereturns" component={EnjoyTheReturns} />

            <ContentRoute exact path="/socialmedia" component={SocialMedia} />
            <ContentRoute
              exact
              path="/property/addProperty"
              component={AddProperty}
            />
            <Redirect to="error/error-v6" />
          </Switch>
        </Suspense>
      ) : null}

      {userInfo?.admin?.role === "admin" ? (
        <Suspense fallback={<LayoutSplashScreen />}>
          <Switch>
            <Redirect exact from="/" to="/dashboard" />
            <ContentRoute exact path="/dashboard" component={DashboardPage} />
            <ContentRoute exact path="/properties" component={Properties} />
            <ContentRoute
              exact
              path="/property/addProperty"
              component={AddProperty}
            />
            <ContentRoute
              exact
              path="/contactUsAdmin"
              component={ContactUsAdmin}
            />

            <Redirect to="error/error-v6" />
          </Switch>
        </Suspense>
      ) : null}
    </>
  );
}
